import type { MarkNotificationAsRead200BasicInfo } from './markNotificationAsRead200BasicInfo';
import type { MarkNotificationAsRead200Data } from './markNotificationAsRead200Data';
import type { MarkNotificationAsRead200Source } from './markNotificationAsRead200Source';
import type { MarkNotificationAsRead200Status } from './markNotificationAsRead200Status';
import type { MarkNotificationAsRead200Target } from './markNotificationAsRead200Target';

export type MarkNotificationAsRead200 = {
  basicInfo: MarkNotificationAsRead200BasicInfo;
  /** @nullable */
  data?: MarkNotificationAsRead200Data;
  source?: MarkNotificationAsRead200Source;
  status: MarkNotificationAsRead200Status;
  target?: MarkNotificationAsRead200Target;
};
